import Statements from './index';
import authRoles from "../../utils/auth.roles";
const StatementRoutes = {
  auth: authRoles.user,
  kyc: false,
  routes: [
    {
        path: "/statements",
        component: Statements,
        exact: true,
      }
  ],
};
export default StatementRoutes;
